import { useReducer } from "react";

import PropTypes from "prop-types";

import numberFormat from "common/source-function/numberFormat";
import scanPrice from "common/source-function/scanPrice";
import totalPrice from "common/source-function/totalPrice";

import ButtonNew from "components/atoms/ButtonNew/index";
import { FaCheckCircle } from "components/atoms/Icon/fa/FaCheckCircle";

import AccountingTab from "./AccountingTab";

const initState = {
  tabIndex: 0,
  paymentType: "monthly",
  accountingValue: 1,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "fee_update_state":
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

const ServiceFeeCalculator = ({ services }) => {
  const priceAccountingPerMonth = (
    pricing,
    transaction,
    xero = 0,
    month = 1
  ) => {
    const price = scanPrice(pricing, transaction);

    return (parseFloat(price) + parseFloat(xero)) * month;
  };
  const [state, dispatch] = useReducer(reducer, {
    ...initState,
    accountingService: services[0],
    xero: { ...services[0]?.xero, checked: services[0]?.xero?.default },
  });

  const updateState = (payload) => {
    dispatch({
      type: "fee_update_state",
      payload,
    });
  };
  const setXero = (checked) => {
    updateState({
      xero: { ...state.xero, checked },
    });
  };
  const setAccountingValue = (value) => {
    const valueTemp = value === "" ? "" : `${value.replaceAll(",", "")}`;
    const accType = state.accountingService?.types.find(
      (item) => item.key === state.paymentType
    );
    const accountingTemp = parseFloat(valueTemp);

    if (!Number.isNaN(accountingTemp) && accType) {
      if (
        accountingTemp >= accType.transaction?.min &&
        accountingTemp <= accType.transaction?.max
      ) {
        updateState({
          accountingValue: accountingTemp,
        });
      }
    } else if (value === "") {
      updateState({
        accountingValue: "",
      });
    }
  };

  return (
    <div
      id="accounting-auditing"
      className="lg:shadow-bbc rounded-3xl lg:bg-white"
    >
      <div className="row">
        <div className="col-12 lg:col-6">
          <div className="pb-7 pt-0 lg:pb-9 lg:pt-9">
            <div>
              <AccountingTab
                setAccountingValue={setAccountingValue}
                accountingValue={state.accountingValue}
                accountingService={state.accountingService}
                xero={state.xero}
                setXero={setXero}
              />
            </div>
          </div>
        </div>
        <div className="col-12 mb-10 lg:col-6 lg:mb-0">
          <div className="h-full rounded-3xl bg-bbc-gradient-3 py-8 px-6 lg:py-12 lg:px-11">
            <div className="mb-8 flex items-end justify-center">
              <p className="text-5xl font-semibold text-white">
                {state.tabIndex === 0 && (
                  <>
                    {state.accountingService?.currencySymbol}
                    {numberFormat(
                      priceAccountingPerMonth(
                        state.accountingService?.types.find(
                          (item) => item.key === state.paymentType
                        )?.pricing,
                        state.accountingValue,
                        state.xero.checked ? state.xero.value : 0
                      )
                    )}
                  </>
                )}
              </p>
              <p className="text-lg font-semibold text-white">
                {state.tabIndex === 0 ? "/Month" : ""}
              </p>
            </div>
            <p className="mb-1 text-center text-white">
              Total yearly estimated cost for{" "}
              {services[state.tabIndex]?.types[state.auditingIndexType]
                ?.costFor ? (
                <>
                  {state.revenue > 0
                    ? services[state.tabIndex]?.types[state.auditingIndexType]
                        ?.costFor
                    : state.accountingService?.name}
                </>
              ) : (
                services[state.tabIndex]?.name
              )}
              :
            </p>
            <p className="mb-8 text-center text-lg font-semibold text-white">
              {state.accountingService?.currencySymbol}
              {numberFormat(
                totalPrice([
                  priceAccountingPerMonth(
                    state.accountingService?.types.find(
                      (item) => item.key === state.paymentType
                    )?.pricing,
                    state.accountingValue,
                    state.xero.checked ? state.xero.value : 0,
                    12
                  ),
                ])
              )}
            </p>
            <div className="mb-8 flex justify-center">
              <ButtonNew
                as="button"
                btnColor="bg-white"
                btnTextColor="text-bbc-primary"
                onClick={async () => {
                  // eslint-disable-next-line no-undef
                  await Tawk_API.toggle();
                }}
              >
                Talk To Us
              </ButtonNew>
            </div>
            <p className="mb-10 text-center text-white">
              * Applied to trading without import/export activities, service
              businesses. Fees applied to other business lines like
              manufacturing, construction, etc. will be adjusted upward.
            </p>
            <p className="text-center text-white">* Excluded: VAT 10%</p>
          </div>
        </div>
        <div className="col-12 block px-6 lg:col-6 lg:hidden">
          <p className="mb-2 text-base font-medium text-bbc-brand-700">
            What&lsquo;s included in Accounting package?
          </p>
          <ul>
            <li className="mt-2 mb-2 flex items-start first:mt-0">
              <div>
                <FaCheckCircle
                  className="mr-2.5 mt-1 block text-bbc-brand-600"
                  size={16}
                />
              </div>
              <span>Monthly/quarterly and yearly tax preparation</span>
            </li>
            <li className="mt-2 mb-2 flex items-start first:mt-0">
              <div>
                <FaCheckCircle
                  className="mr-2.5 mt-1 block text-bbc-brand-600"
                  size={16}
                />
              </div>
              <span>Bookkeeping service and FSs compilation</span>
            </li>
            <li className="mt-2 flex items-start first:mt-0">
              <div>
                <FaCheckCircle
                  className="mr-2.5 mt-1 block text-bbc-brand-600"
                  size={16}
                />
              </div>
              <span>Appointment of Chief Accountant</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ServiceFeeCalculator;

ServiceFeeCalculator.propTypes = {
  services: PropTypes.array,
};

ServiceFeeCalculator.defaultProps = {
  services: [],
};
